<template>
  <div class="d-flex flex-column align-items-center pt-xxl">
    <IconOrigamiDress
      :width="300"
      :height="300"
      color="#520845"
      class="mx-auto dress-animation"/>
    <div class="text-wrapper text-center">
      <h3>Preparing styles just for you.</h3>
      <h5>Next, get your recommended <br> Membership plan.</h5>
    </div>
  </div>
</template>

<script setup>
import IconOrigamiDress from '@shared/components/icons/IconOrigamiDress.vue'
</script>

<style lang="scss" scoped>
.text-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 84px;
}
.dress-animation {
  animation: spin 3s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg)  scale(1);
  }
  50% {
    transform: rotate(180deg) scale(.5);
  }
  100% {
    transform: rotate(360deg)  scale(1);
  }
}
</style>
